import React from 'react';
import { useLanguage } from '../../../helpers/language-context';

const Intro = () => {
  const { translations } = useLanguage();

  return (
    <section className="bg-white">
      <div className="grid grid-cols-1 md:grid-cols-2 items-center gap-8">
        <div className="space-y-6">
          <h2 className="text-4xl md:text-5xl lg:text-6xl text-[#28357B] mb-8">
            {translations.about.behindKSSB}
          </h2>
          <div className="space-y-2 mb-4">
            <p
              className="text-md text-black"
              dangerouslySetInnerHTML={{ __html: translations.about.behindKSSBDesc }}
            />
          </div>
        </div>

        <div className="w-full h-full">
          <img
            src="/assets/images/section-img/force_behind_kssb.jpg"
            alt="Force Behind KSSB"
            className="w-full h-full object-cover rounded-xl"
          />
        </div>
      </div>
    </section>
  );
};

export default Intro;
